import { call } from 'vuex-pathify';

export default {
  methods: {
    getBboxGetLayerFeatures: call('layers/getLayerFeatures'),
    async getFeaturesBbox({ layerId, featuresIds } = {}) {
      try {
        const dataSourceName = this.$store.get('layers/layers')[layerId]?.data_source_name;
        const dataSourceMetadata = this.$store.get('layers/metadata')[dataSourceName];
        const r = await this.getBboxGetLayerFeatures({
          features_filter: {
            $IN: {
              [dataSourceMetadata?.attributes_use_datasource_qualified_names
                ? dataSourceMetadata?.attributes_schema.id_name
                : `${dataSourceName}.${dataSourceMetadata?.attributes_schema.id_name}`]: featuresIds,
            },
          },
          layer_id: layerId,
          params: {
            with_collection_bbox: true,
            with_features: false,
          },
        });
        return r.data.data.bbox.map(coords => +coords);
      } catch {
        //
      }
    },
  },
};
